module.exports = __webpack_public_path__ + "static/media/Plus TimeDark.7bbd395e.svg";